import { defaultNavigationProps } from "../../../Navigator";
import MainWrapp from "../Components/MainWrapp";
import React from "react";
const LicensesAndCertificates:React.FC<defaultNavigationProps> = ({navigation, route}) => {

    return (
        <MainWrapp>
            <></>
        </MainWrapp>
    )
} 

export default LicensesAndCertificates